import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=57b978a2"
import script from "./Hot.vue?vue&type=script&lang=js"
export * from "./Hot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports